import RsvpLiteSessionsPage from './rsvp-lite-sessions';
import RsvpService from '../../../services/RsvpService';
import EngageRequest from '../../../services/EngageRequest';

const state = {
  	name: 'rsvp-lite-manage-sessions',
  	url: '/rsvp-lite/manage-sessions/:account_uuid/:contact_uuid/:event_id?{env}',
  	component: RsvpLiteSessionsPage,
    resolve: [
        {
            token: 'data',
            deps: ['$transition$'],
            resolveFn: (trans) => new RsvpService().getRsvp(trans.params())
        },
        {
            token: 'account',
            deps: ['data'],
            resolveFn: (data) => data.account
        },
        {
            token: 'attendances',
            deps: ['data'],
            resolveFn: (data) => data.attendances
        },
        {
            token: 'all_sessions',
            deps: ['$transition$'],
            resolveFn: (trans) => EngageRequest.get(`/rsvp/${trans.params().account_uuid}/${trans.params().contact_uuid}/${trans.params().event_id}/sessions`, {include_closed: 1})
        },
        {
            token: 'booked_sessions',
            deps: ['data'],
            resolveFn: (data) => data.sessions
        },
        {
            token: 'sessions',
            deps: ['all_sessions', 'booked_sessions', 'attendances'],
            resolveFn: (allSessions, bookedSessions, attendances) => {
                return allSessions.reduce((sessions, session) => {
                    const time = (bookedSessions.find(s => s.id === session.id) || {}).time || null;
                    const attendance = attendances.find(attendance => attendance.event_id === (time || {}).id);
                    sessions.push(Object.assign({}, session, bookedSessions.find(s => s.id === session.id), {attendance: attendance || null}));
                    return sessions;
                }, []);
            }
        }
    ]
};

export default state;
